/*
 * @Author: tyz tyz.bnu@gmail.com
 * @Date: 2025-03-13 14:08:41
 * @LastEditors: tyz tyz.bnu@gmail.com
 * @LastEditTime: 2025-03-13 14:55:43
 * @FilePath: \undefinedd:\projects\frontEnd\vue-cesium-start\src\common\js\config.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const CesiumIonDefaultAccessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIyYTNhM2ZiNi04OGIyLTQ4ZDEtODM1NC05N2FmZDljMDZmYzYiLCJpZCI6MjA5NTU0LCJpYXQiOjE3MTM0MDY1Mzh9.cxWqNA6MKdDPvBsA4cat24RdAHyet4nlMJIxz5Rf7IU'
export const TianDiTuToken = '10e36908782a69691cc52e4ef7feab78'